var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0.75C12.6906 0.75 12.6297 0.760938 12.5687 0.785938L3.5625 4.40469H1C0.8625 4.40469 0.75 4.52031 0.75 4.66406V9.33594C0.75 9.47969 0.8625 9.59531 1 9.59531H2.5875C2.52969 9.77656 2.5 9.96875 2.5 10.1641C2.5 11.1937 3.34062 12.0312 4.375 12.0312C5.24062 12.0312 5.97031 11.4437 6.18594 10.65L12.5703 13.2156C12.6312 13.2391 12.6922 13.2516 12.7516 13.2516C13.0156 13.2516 13.2516 13.0297 13.2516 12.7328V1.26875C13.25 0.971875 13.0156 0.75 12.75 0.75ZM4.375 10.9109C3.96094 10.9109 3.625 10.5766 3.625 10.1641C3.625 9.98906 3.68594 9.82187 3.79687 9.68906L5.12344 10.2219C5.09219 10.6062 4.76875 10.9109 4.375 10.9109Z",
    fill: "#27A18A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement_icon.e25604f2a3fe9df0f70145fb177142db.svg";
export { ForwardRef as ReactComponent };